var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "productTrackerContactsInfoPopup", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog info-popup" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c("span", [
                _vm._v("Project Contacts "),
                !_vm.listType
                  ? _c("span", [
                      _c("img", {
                        staticClass: "chevorn-right-img ml-5 mt-2",
                        attrs: {
                          src: "/static/images/icons/chevron_right.svg",
                          alt: "chevron-right-icon",
                        },
                      }),
                      _vm._v(" Modify Contacts"),
                    ])
                  : _vm._e(),
              ]),
              _c("img", {
                staticClass: "close-icon cursor-pointer",
                attrs: {
                  alt: "close-icon",
                  src: "/static/images/icons/close_icon.svg",
                },
                on: { click: _vm.closePopup },
              }),
            ]),
            _c(
              "div",
              { staticClass: "modal-body generic-body" },
              [
                _vm.listType
                  ? [
                      _c("div", { staticClass: "row pt-15 pb-20" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-8 modal-status-header pr-20",
                          },
                          [
                            _vm._v(
                              " The followings contacts from your team will receive updates on the status for this product family. "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-4 xs-mt-10" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-block emergo-white-button",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getTeamMembers()
                                  },
                                },
                              },
                              [_vm._v(" Modify Contacts ")]
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "info-table" }, [
                        _c("table", { staticClass: "table status-table" }, [
                          _c("thead", [
                            _c(
                              "tr",
                              {
                                class: {
                                  "custom-padding": !_vm.checkRolePermissions,
                                },
                              },
                              [
                                _vm._l(
                                  _vm.infoheaders,
                                  function (header, index) {
                                    return [
                                      _c("th", { key: index }, [
                                        _vm._v(" " + _vm._s(header.name) + " "),
                                        header.key !== "directives" &&
                                        header.key !== "trade_name"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "sort pl-8",
                                                class:
                                                  _vm.sortOrders[header.key] > 0
                                                    ? "asc"
                                                    : "desc",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.sortBy(
                                                      header.key
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "/static/images/icons/sortDesc.svg",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.contactsData, function (data, index) {
                                return _c(
                                  "tr",
                                  { key: index },
                                  [
                                    _vm._l(
                                      _vm.infoheaders,
                                      function (header, headerindex) {
                                        return [
                                          _c("td", { key: headerindex }, [
                                            header.key === "modified_on"
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(data.audit_flag) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f("infoDate")(
                                                          data[header.key]
                                                        )
                                                      )
                                                  ),
                                                ])
                                              : header.key === "contact"
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        data[header.key].name ||
                                                          "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      data[header.key] || "-"
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              }),
                              !_vm.contactsData.length
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "center",
                                        attrs: { colspan: "100%" },
                                      },
                                      [_vm._v("No Contacts")]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "modal-status-header pt-15 pb-20" },
                        [
                          _vm._v(
                            " Please note that changes made here only apply to this product family for "
                          ),
                          _c("span", { staticClass: "fw-500" }, [
                            _vm._v(_vm._s(_vm.countryName)),
                          ]),
                          _vm._v(
                            ". For changes in other markets, please switch to the appropriate country tab. "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "custom-height" }, [
                        _c("div", { staticClass: "row pt-5" }, [
                          _vm._m(0),
                          _c(
                            "div",
                            { staticClass: "col-xs-12" },
                            [
                              _c(
                                "multiselect",
                                {
                                  staticClass:
                                    "multiselect-single-dropdown multiselect-multiple",
                                  class: !_vm.selectedContacts.length
                                    ? "un-selected"
                                    : "",
                                  attrs: {
                                    showLabels: false,
                                    "close-on-select": false,
                                    placeholder: "Select Contacts",
                                    label: "first_name",
                                    "track-by": "id",
                                    multiple: true,
                                    searchable: true,
                                    "clear-on-select": false,
                                    options: _vm.usersList,
                                    value: _vm.selectedContacts,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "selection",
                                      fn: function ({ values, isOpen }) {
                                        return _c(
                                          "div",
                                          { staticClass: "selection-count" },
                                          [
                                            !isOpen
                                              ? [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/filter.svg",
                                                      alt: "filter-icon",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "selected-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(values.length) +
                                                          " Selected"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : isOpen
                                              ? [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/filter.svg",
                                                      alt: "filter-icon",
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return _c("span", {}, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex",
                                              on: {
                                                input: function ($event) {
                                                  return _vm.selectContact(
                                                    props.option.user_id,
                                                    _vm.disableContactNum
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "checkbox inline-checkbox",
                                                },
                                                [
                                                  _c("label", [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        value: props.option,
                                                        checked:
                                                          _vm.selectedContacts.includes(
                                                            props.option.user_id
                                                          ),
                                                      },
                                                    }),
                                                    _c("span", {
                                                      staticClass: "cr",
                                                      class: {
                                                        "disabled-checkbox":
                                                          _vm.disableContactNum &&
                                                          _vm.selectedContacts
                                                            .length ==
                                                            _vm.disableContactNum,
                                                      },
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-capitalize",
                                                  class: {
                                                    "font-bold":
                                                      _vm.selectedContacts.includes(
                                                        props.option.user_id
                                                      ),
                                                    "font-wt-400":
                                                      !_vm.selectedContacts.includes(
                                                        props.option.id
                                                      ),
                                                    "disabled-text":
                                                      _vm.disableContactNum &&
                                                      !_vm.selectedContacts.includes(
                                                        props.option.user_id
                                                      ) &&
                                                      _vm.selectedContacts
                                                        .length ===
                                                        _vm.disableContactNum,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectContact(
                                                        props.option.user_id,
                                                        _vm.disableContactNum
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.option.first_name
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        props.option.last_name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "noResult" },
                                      slot: "noResult",
                                    },
                                    [_vm._v("No matching data")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm.selectedContacts.length
                          ? _c(
                              "div",
                              { staticClass: "row mt-20 col-xs-12" },
                              _vm._l(_vm.selectedContacts, function (each) {
                                return _c(
                                  "span",
                                  {
                                    key: each,
                                    staticClass:
                                      "selected-names text-capitalize mr-10 mb-20",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getContact(each).first_name
                                        ) +
                                        " " +
                                        _vm._s(_vm.getContact(each).last_name) +
                                        " "
                                    ),
                                    _c("img", {
                                      staticClass: "ml-10 cursor-pointer",
                                      attrs: {
                                        src: "/static/images/icons/close_blue_icon.svg",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectContact(
                                            each,
                                            _vm.disableContactNum
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]),
                    ],
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                !_vm.listType
                  ? [
                      _c("div", { staticClass: "col-xs-4 col-sm-3 p-0" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block emergo-white-button",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.listType = true
                              },
                            },
                          },
                          [_vm._v(" Back ")]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-4 col-sm-3 col-sm-offset-3 p-0 align-right",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block emergo-white-button",
                              attrs: { type: "button" },
                              on: { click: _vm.closePopup },
                            },
                            [_vm._v(" Cancel ")]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "col-xs-4 col-sm-3 p-0" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block emergo-green-button",
                            attrs: {
                              type: "button",
                              disabled: _vm.isUpdateDisable,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateContacts()
                              },
                            },
                          },
                          [_vm._v(" Update ")]
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group col-xs-12 mb-10" }, [
      _vm._v(" Select Project Contacts"),
      _c("span", { staticClass: "required-astreisk" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }